
var stache = require('can/view/stache/stache');
module.exports = stache("<div class=\"js-text\">{{{text}}}</div>\r\n");